export const Dark = {
  palette: {
    mode: "dark",
    type: "dark",
    action: {
      selected: "#ffffff",
    },
    primary: {
      main: "#1cc8d4",
      dark: "#1b8187",
      contrastText: "#000000",
    },
    secondary: {
      main: "#006bf5",
    },
    text: {
      disabled: "#c2f9f9",
      hint: "#4bdeff",
      secondary: "rgba(15,192,224,0.94)",
      primary: "#8bd1fb",
    },
    success: {
      main: "#9afff3",
    },
    divider: "rgba(255,255,255,0.87)",
  },
  typography: {
    body2: {
      fontSize: "0.8rem",
    },
  },
};
